$bog_qr $mol_svg_root
	uri \
	module_radius 0.35
	finder_radius 1.2
	gradient_angle 45
	error_correction \M
	quiet_zone 2
	center /
	gradient_id \qr-grad
	gradient_fill \url(#qr-grad)
	gradient_stops /
		\var(--mol_theme_special)
		\var(--mol_theme_focus)
	Stop* $mol_svg
		dom_name \stop
		attr *
			^
			offset <= stop_offset* \0%
			stop-color <= stop_color* \
	view_box <= qr_view_box \0 0 1 1
	sub /
		<= Defs $mol_svg
			dom_name \defs
			sub /
				<= Gradient $mol_svg
					dom_name \linearGradient
					attr *
						^
						id <= gradient_id
						x1 <= grad_x1 \0
						y1 <= grad_y1 \0
						x2 <= grad_x2 \1
						y2 <= grad_y2 \1
					sub <= gradient_stop_list /
		<= Modules $mol_svg_path
			geometry <= modules_d \
			attr *
				^
				fill <= gradient_fill
		<= Rings $mol_svg_path
			geometry <= rings_d \
			attr *
				^
				fill <= gradient_fill
				fill-rule \evenodd
		<= Centers $mol_svg_path
			geometry <= centers_d \
			attr *
				^
				fill <= gradient_fill
		<= Center_wrap $mol_svg
			dom_name \foreignObject
			attr *
				^
				x <= center_x \0
				y <= center_y \0
				width <= center_size \0
				height <= center_size
			sub /
				<= Center_body $mol_view
					sub <= center
